import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["colors", "className", "children", "clsPrefix", "dataBadge", "dataBadgePlacement", "showZero", "count", "overflowCount", "dot", "color", "title", "status", "offset", "text", "size"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src";
/**
 *  badge 默认显示内容1
 */

var propTypes = {
  /**
   * @title 颜色
   */
  colors: PropTypes.oneOf(['primary', 'dark', 'success', 'info', 'warning', 'danger', 'default']),

  /**
   * @title 边角显示内容
   */
  dataBadge: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),

  /**
   * @title 显示位置
   * */
  dataBadgePlacement: PropTypes.oneOf(['top', 'bottom']),

  /**
  * @title 不展示数字，只有一个小红点
  * */
  dot: PropTypes.bool,

  /**
  * @title 自定义小圆点的颜色
  * */
  color: PropTypes.string,

  /**
   * @title 显示数值
   * */
  count: PropTypes.node,

  /**
   * @title 展示封顶的数字值
   * */
  overflowCount: PropTypes.number,

  /**
   * @title 当数值为 0 时，是否展示
   * */
  showZero: PropTypes.bool,

  /**
   * @title 设置 Badge 显示状态
   * */
  status: PropTypes.oneOf(['processing', 'error', 'success', 'warning', 'default']),

  /**
   * @title 在设置了 count 的前提下有效，设置小圆点的大小
   * */
  size: PropTypes.oneOf(['small', 'sm', 'default']),

  /**
   * @title 在设置了 status 的前提下有效，设置状态点的文本
   * */
  text: PropTypes.node,

  /**
   * @title 设置鼠标放在状态点上时显示的文字
   * */
  title: PropTypes.string
};
var defaultProps = {
  colors: 'primary',
  dataBadgePlacement: 'top',
  dot: false,
  showZero: false,
  dataBadge: null,
  count: null,
  overflowCount: 99,
  size: 'default',
  title: null,
  status: null,
  text: null,
  color: null
};
var colorsMap = {
  primary: 'primary',
  default: 'primary',
  secondary: 'secondary',
  accent: 'accent',
  success: 'success',
  info: 'info',
  processing: 'info',
  warning: 'warning',
  danger: 'danger',
  error: 'danger',
  dark: 'dark',
  light: 'light'
};
var sizeMap = {
  sm: 'sm',
  small: 'sm'
};
var Badge = (_dec = WebUI({
  name: "badge",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Badge, _React$Component);

  var _super = _createSuper(Badge);

  function Badge(props) {
    _classCallCheck(this, Badge);

    return _super.call(this, props);
  }

  _createClass(Badge, [{
    key: "render",
    value: function render() {
      var _count;

      var _this$props = this.props,
          colors = _this$props.colors,
          className = _this$props.className,
          children = _this$props.children,
          clsPrefix = _this$props.clsPrefix,
          dataBadge = _this$props.dataBadge,
          dataBadgePlacement = _this$props.dataBadgePlacement,
          showZero = _this$props.showZero,
          count = _this$props.count,
          overflowCount = _this$props.overflowCount,
          dot = _this$props.dot,
          color = _this$props.color,
          title = _this$props.title,
          status = _this$props.status,
          offset = _this$props.offset,
          text = _this$props.text,
          size = _this$props.size,
          others = _objectWithoutProperties(_this$props, _excluded);

      var numberedDisplayCount;
      count = count - 0 == count ? count - 0 : count;
      var countHack = (_count = count) !== null && _count !== void 0 ? _count : dataBadge;

      if (typeof countHack === 'number' && typeof overflowCount === 'number') {
        numberedDisplayCount = countHack > overflowCount ? "".concat(overflowCount, "+") : countHack;
      }

      var isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0;
      var hasStatus = status !== null && status !== undefined || color !== null && color !== undefined;
      var showAsDot = dot && !isZero || hasStatus || !countHack && countHack !== 0;
      var mergedCount = showAsDot ? '' : numberedDisplayCount;
      var isEmpty = mergedCount === null || mergedCount === undefined || mergedCount === '';
      var titleNode = title !== null && title !== void 0 ? title : typeof countHack === 'string' || typeof countHack === 'number' ? countHack : undefined;
      var isConsumer = /*#__PURE__*/React.isValidElement(countHack);
      var isHidden = (isEmpty || isZero && !showZero) && !showAsDot && !isConsumer;
      var displayNode = isConsumer ? countHack : numberedDisplayCount;
      var textNode = showAsDot && text && !isHidden ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-status-text")
      }, text) : undefined;
      var clsObj = {};

      if (className) {
        clsObj[className] = true;
      }
      /**
       *  以u-badge起头的颜色类判断
       */


      var colorHack = status || colors;

      if (colorsMap[colorHack]) {
        clsObj["".concat(clsPrefix, "-").concat(colorsMap[colorHack])] = true;
      } else {
        //默认为primary
        clsObj["".concat(clsPrefix, "-primary")] = true;
      }

      if (countHack || isZero || showAsDot) {
        clsObj["data-badge"] = true;
      }

      if (dataBadgePlacement) {
        clsObj["data-badge-".concat(dataBadgePlacement)] = true;
      }

      clsObj["".concat(clsPrefix, "-custom-component")] = isConsumer;
      clsObj["".concat(clsPrefix, "-status")] = hasStatus;
      clsObj["".concat(clsPrefix, "-not-a-wrapper")] = !children;
      var classNames = classnames(clsPrefix, clsObj);
      var childClsObj = {};
      childClsObj["".concat(clsPrefix, "-dot")] = showAsDot && !textNode; // <Badge dot><a href="#" className="badge-example" /></Badge>

      childClsObj["".concat(clsPrefix, "-status-dot")] = showAsDot && !!textNode; // <Badge status="success" text="success" />

      childClsObj["".concat(clsPrefix, "-").concat(sizeMap[size])] = !!sizeMap[size] && !showAsDot;
      var childClassNames = classnames('data-icon', childClsObj);
      var childStyle = {
        background: color,
        right: offset && -offset[0],
        marginTop: offset && offset[1]
      };
      return /*#__PURE__*/React.createElement("span", _extends({
        className: classNames
      }, others), /*#__PURE__*/React.createElement("span", null, children, !isHidden && /*#__PURE__*/React.createElement("span", {
        title: showAsDot ? '' : titleNode,
        style: childStyle,
        className: childClassNames
      }, showAsDot ? '' : displayNode), textNode));
    }
  }]);

  return Badge;
}(React.Component)) || _class);
Badge.propTypes = propTypes;
export default Badge;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-badge/src/Badge.js